export class AbortError extends Error {
  message: string;
  name: string;

  constructor(message: string) {
    super(message);
    this.message = message;
    this.name = 'AbortError';
  }
};

export class ConfigError extends Error {
  message: string;
  name: string;

  constructor(message: string) {
    super(message);
    this.message = message;
    this.name = 'ConfigError';
  }
};

export class AlreadyExistsError extends Error {
  message: string;
  name: string;

  constructor(message: string) {
    super(message);
    this.message = message;
    this.name = 'AlreadyExistsError';
  }
};
